const ATTEMPT_KEY = "helios.site-release-attempt";
const RELOAD_COOLDOWN_MS = 10 * 60 * 1000;

export function bundleVersion(source, origin) {
  try {
    const url = new URL(source, origin);
    if (url.origin !== origin) return null;
    return /^\/static\/js\/main\.([a-f0-9]{8,})\.js$/.exec(url.pathname)?.[1] || null;
  } catch { return null; }
}

export function loadedSiteVersion(doc = document, origin = window.location.origin) {
  for (const script of doc.scripts) {
    const version = script.src && bundleVersion(script.src, origin);
    if (version) return version;
  }
  // CRA development uses bundle.js, not an immutable release. Do not refresh the preview for HMR.
  return null;
}

export async function latestSiteVersion(origin, signal) {
  const url = new URL("/asset-manifest.json", origin);
  url.searchParams.set("_helios_check", String(Date.now()));
  const response = await fetch(url, { cache: "no-store", credentials: "same-origin", signal,
    headers: { "Cache-Control": "no-cache", Accept: "application/json" } });
  if (!response.ok || !response.headers.get("content-type")?.includes("application/json")) return null;
  const manifest = await response.json();
  const main = manifest?.files?.["main.js"];
  return typeof main === "string" ? bundleVersion(main, origin) : null;
}

export function claimAutomaticRefresh(target, storage, now = Date.now()) {
  try {
    const store = storage || window.sessionStorage;
    const raw = store.getItem(ATTEMPT_KEY);
    let previous;
    try { previous = JSON.parse(raw); } catch { previous = null; }
    if (previous?.target === target && now - previous.at < RELOAD_COOLDOWN_MS) return false;
    store.setItem(ATTEMPT_KEY, JSON.stringify({ target, at: now }));
    return true;
  } catch {
    // Without durable loop protection, only an explicit visitor-initiated refresh is safe.
    return false;
  }
}

export function recordManualRefresh(target) {
  try { window.sessionStorage.setItem(ATTEMPT_KEY, JSON.stringify({ target, at: Date.now() })); } catch { /* No automatic refresh in this case. */ }
}